import { registerCapability } from '@/delivery-type-plugin/platform/capability-registry';

import { EbmResourceConfigBlock } from './EbmResourceConfigBlock';
import { EBM_RESOURCE_CONFIG_FIELD_KEY_LIST } from './fieldKeys';
import { resolveEbmResourceConfigPaths } from './resolvePaths';
import type { EbmResourceConfigBlockOptions } from './types';

registerCapability<EbmResourceConfigBlockOptions>({
  key: 'ebm-nodes',
  fields: [...EBM_RESOURCE_CONFIG_FIELD_KEY_LIST],
  component: EbmResourceConfigBlock,
  defaultPaths: (prefix) => resolveEbmResourceConfigPaths(prefix),
  resolvePaths: (prefix) => resolveEbmResourceConfigPaths(prefix),
});

export { EbmResourceConfigBlock } from './EbmResourceConfigBlock';
export { getEbmResourceConfigurations } from './api';
export { EBM_NODE_RESOURCE_CODE } from './constants';
export type { EbmResourceConfigurationRecord, EbmResourceConfigBlockOptions, EbmResourceConfigBlockProps } from './types';
